import { $can, $hasFeature } from '@/core/utils/VueAcl'

export default {
  sectionName: 'LeftNavigation_MLStudio',
  icon: 'deep-learning',
  index: '9',
  routeName: 'MlStudio',
  isAllowed: () => $hasFeature('mlStudioAccessible') && $can('viewProjectItem'),
  isEnabled: () => $hasFeature('mlStudio')
}



// WEBPACK FOOTER //
// ./src/common/components/navigation/navigation-section-items/ml-studio.js